import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installUnityKeyboardIsolation } from './utils/unityKeyboard';
import './styles/globals.css';

// Unity survives gallery route changes, so input isolation has the same lifetime.
installUnityKeyboardIsolation();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
